var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStackedAreaUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 16.7208V14.6126L9.13108 12.2356C9.67235 12.0552 10.2539 12.0328 10.8074 12.1712L13.6773 12.8887C13.8619 12.9348 14.0557 12.9274 14.2361 12.8673L22 10.2793V12.3875L14.8686 14.7646C14.3273 14.9451 13.7458 14.9674 13.1923 14.829L10.3223 14.1115C10.1378 14.0654 9.94396 14.0728 9.76354 14.133L2 16.7208Z",
    fill: "#9B9DA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 7.00123C20 6.19705 19.099 5.72182 18.4353 6.17595L15.3068 8.31663C14.5988 8.80108 13.7173 8.95926 12.8851 8.7512L10.5371 8.1642C10.2869 8.10166 10.0223 8.13817 9.79841 8.2661L4.50386 11.2916C4.19229 11.4696 4 11.8009 4 12.1598V16.9992C4 17.5514 4.44772 17.9992 5 17.9992H19C19.5523 17.9992 20 17.5514 20 16.9992V7.00123ZM17.3059 4.52537C19.2969 3.16298 22 4.5887 22 7.00123V16.9992C22 18.656 20.6569 19.9992 19 19.9992H5C3.34315 19.9992 2 18.656 2 16.9992V12.1598C2 11.0832 2.57686 10.0892 3.51158 9.55507L8.80613 6.52961C9.47777 6.14582 10.2717 6.0363 11.0222 6.22391L13.3702 6.81091C13.6476 6.88027 13.9414 6.82754 14.1774 6.66606L17.3059 4.52537Z",
    fill: "#9B9DA1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackedAreaUp);
export default __webpack_public_path__ + "static/media/stacked-area-up.3813a1ceff1b18053e98948cfbc1b944.svg";
export { ForwardRef as ReactComponent };